import { Spin } from "antd";
import styled from "styled-components";
import { DesignTokens } from "../../common-ui/styles/design-tokens";

type LoadingDefaultSpinIndicatorProps = {
  isShown: boolean;
  children?: React.ReactNode;
};
const { colors } = DesignTokens;

const Container = styled.div`
  position: fixed;
  z-index: 1;
  top: 50%;
  left: 50%;
`;

const RedSpin = styled(Spin)`
  color: ${colors.main.primary} !important;

  .ant-spin-dot-item {
    background-color: ${colors.main.primary} !important;
  }
`;

const LoadingDefaultSpinIndicator: React.FC<
  LoadingDefaultSpinIndicatorProps
> = ({ isShown, children }) => {
  if (isShown) {
    return (
      <Container>
        <RedSpin></RedSpin>
      </Container>
    );
  }

  return <>{children}</>;
};

export default LoadingDefaultSpinIndicator;
